import { ENTERED_WIZARD, CREATE_REQUEST_ID } from './types/SelectionCriteriaWizardActionTypes';

export const enteredWizard = reportId => ({
  type: ENTERED_WIZARD,
  reportId,
});

export const createRequestId = requestId => ({
  type: CREATE_REQUEST_ID,
  requestId,
});
